// extracted by mini-css-extract-plugin
module.exports = {"form":"SettingsUpdateForms_form__DtdXf","field":"SettingsUpdateForms_field__zmhLX","errorText":"SettingsUpdateForms_errorText__2KS0s"};